__turbopack_context__.v({
  "circle": "YJlerW_circle",
});
